<template>
  <div id="app">
    <template v-if="officeReady">
      <div v-if="auth && auth.userId">
        <!--        <Header />-->
        <router-view />
      </div>
      <div v-else>
        <LoginForm />
      </div>
    </template>
    <template v-else>
      <SideloadAddinMsg />
    </template>
  </div>
</template>
<style scoped>
#app {
  padding: 10px;
}
</style>
<script>
/* global document, Office, Word */
import { mapActions } from "vuex";

// @ is an alias to /src
import SideloadAddinMsg from "@/components/SideloadAddinMsg";
import Header from "@/components/Header";
import LoginForm from "@/pages/Auth/index";

export default {
  components: { SideloadAddinMsg, Header, LoginForm },
  data() {
    return {
      officeReady: false,
      timeout: undefined
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    ...mapActions({
      initAuth: "auth/init"
    }),

    recallOffice() {
      const vm = this;
      this.timeout = setTimeout(() => {
        vm.officeReadyCall();
      }, 2000);
    },
    async officeReadyCall() {
      try {
        // Kiểm tra Office
        const info = await Office.onReady();
        if (info.host === Office.HostType.Word) {
          this.officeReady = true;
          clearTimeout(this.timeout);
        }
      } catch (error) {
        this.recallOffice();
        console.log("Error", error);
      }
    }
  },
  created() {
    // Kiểm tra đăng nhập trước
    this.initAuth();
    this.officeReadyCall();
  }
};
</script>
